import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function EntranceAnimationInView({ children }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <motion.span
      ref={ref}
      initial={{ opacity: 0, filter: "blur(4px)", y: 10 }}
      animate={
        isInView
          ? { opacity: 1, filter: "blur(0px)", y: 0 }
          : { opacity: 0, filter: "blur(4px)", y: 10 }
      }
      transition={{
        duration: 0.3,
        delay: 0.3,
        ease: "easeInOut",
      }}
    >
      {children}
    </motion.span>
  );
}
